module.exports = __webpack_public_path__ + "static/kcdc2018-59de55e44b8783c9f4e93d3607bf2165.jpeg";